import * as React from 'react'
import { designTokens } from '../../lib/design-tokens'

type IconProps = React.SVGProps<SVGSVGElement> & {
  color?: string
  strokeWidth?: string | number
}

const handleScaleX = 8 / 9.5
const handleScaleY = 7 / 8.5

export const BagIcon = ({
  width = 24,
  height = 24,
  color = designTokens.colors.text.primary,
  strokeWidth = designTokens.borders.widths.advertisingCardIconMobile,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    focusable="false"
    aria-hidden="true"
    {...props}
  >
    <rect
      x="4"
      y="8"
      width="16"
      height="13"
      rx="4"
      stroke={color}
      strokeWidth={strokeWidth}
      fill="none"
    />
    <g transform={`translate(8 3) scale(${handleScaleX} ${handleScaleY})`}>
      <path
        d="M8.75 7.75V4.75C8.75 2.54086 6.95914 0.75 4.75 0.75C2.54086 0.75 0.75 2.54086 0.75 4.75L0.75 7.75"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </g>
  </svg>
)

BagIcon.displayName = 'BagIcon'
